import { constants, tripDestinations, employeeCompanies, transportationMethods, routeCreatingTypes } from '../../constants.js';
import i18next from "../../i18n.js";
export function checkEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email));
}
export function checkCompanyRegisterCode(code) {
    try {
        if (!code) return false;
        const re = /^\d{8}$/;
        if (!re.test(code))
            return false;
        var number = parseInt(code);
        var getSum = function (shift = false, step = 0) {
            let controlSum = 0;
            for (var i = 0; i < 7; i++) {
                var multiplayer = i + 1;
                if (shift)
                    multiplayer = i === 0 ? 7 : i;
                multiplayer += step;
                controlSum += (parseInt(code[i]) * multiplayer);
            }
            return controlSum % 11;
        }
        var lastNumber = parseInt(code[7]);
        const shift = !(number < 30000000 || number > 60000000);
        let sum = getSum(shift);
        if (sum < 10)
            return sum === lastNumber;
        sum = getSum(shift, 2);
        return sum < 10 ? sum === lastNumber : false;
    }
    catch (e) { return false; }
}
export function checkPassword(password) {
    const re1 = /^.{0,}[А-Яа-я\s].{0,}$/;
    const re2 = /^.{0,}[A-Z].{0,}$/;
    const re3 = /^.{0,}[a-z].{0,}$/;
    const re4 = /^.{0,}[0-9].{0,}$/;
    const re5 = /^.{0,}[^A-Za-z0-9А-Яа-я\s].{0,}$/;
    return password && !re1.test(password) && re2.test(password) && re3.test(password) && re4.test(password) && re5.test(password);
}
export function checkFileName(name) {
    let re = /^[^a-zA-Zа-яА-Я0-9\-_\+='\x20].{0,}$/;
    return !re.test(name.trim());
}
export function checkMFO(value) {
    const re = /^\d{6}$/;
    return re.test(value);
}
export function checkSystemName(value) {
    return /^(?![0-9])[a-zA-Z-0-9_ ]+$/.test(value);
}
export function checkBankScore(value) {
    var re = /^UA\d{27}$/;
    return re.test(value);
}
export function checkBankCard(value) {
    var re = /^\d{16}$/;
    return re.test(value);
}
export function checkIPN(value) {
    const re = /^\d{10}$/;
    return re.test(value);
}

export function getFileAttachmentErrorMessage(file, allowedExtensions, maxFileSize) {
    let errorMessage;
    try {
        let fileName = file?.name?.toLowerCase();
        if (allowedExtensions && !allowedExtensions.some(ex => fileName.endsWith(ex))) {
            errorMessage = i18next.t("invalidFileFormatMessage", { extensions: allowedExtensions.join(', ') });
        }
        if (maxFileSize && maxFileSize < file?.size) {
            errorMessage = i18next.t("wrongFileZize", { size: Math.round((maxFileSize / (1024 * 1024))) });
        }
    }
    catch { }
    return errorMessage;
}

export function checkRouteForms(documentData, fieldName, navigationIndex) {
    let result = !!documentData.properties[fieldName];
    let errorElementName = '';
    let i = 0;
    let subform = null;
    if (result) {
        let count = documentData.properties[fieldName].length;
        if (documentData.properties['sx:btBusinessTripDestination'] === tripDestinations.abroad
            || !documentData.properties['sx:btMultipleRoutes']) {
            count = 1;
        }
        for (i = 0; i < count; i++) {
            const checkResult = checkRouteForm(documentData, i, fieldName, navigationIndex);
            if (!checkResult.result) {
                result = false;
                errorElementName = checkResult.errorElementName;
                subform = checkResult.subform;
                break;
            }
        }
    }
    return {
        result,
        errorElementName,
        formIndex: i,
        subform
    };
}

export function checkRouteForm(documentData, formIndex, fieldName, navigationIndex) {
    let result = true;
    let errorElementName = '';
    let subform = null;
    let i = formIndex;

    const isAbroad = documentData.properties["sx:btBusinessTripDestination"] === tripDestinations.abroad;
    const form = documentData.properties[fieldName][i];

    switch (navigationIndex) {
        case 1:
            if (result && isAbroad && !form.properties["sx:pbtCountryBusinessTrip"]) {
                result = false;
                errorElementName = `${fieldName}---${i}---sx:pbtCountryBusinessTrip`;
            }
            if (result && !isAbroad && !form.properties["sx:pbtRegion"] && !form.properties['sx:pbtReturnHome']) {
                result = false;
                errorElementName = `${fieldName}---${i}---sx:pbtRegion`;
            }
            if (result && isAbroad && !form.properties["sx:pbtCity"]) {
                result = false;
                errorElementName = `${fieldName}---${i}---sx:pbtCity`;
            }
            if (result && !isAbroad && !form.properties["sx:pbtLocality"]) {
                result = false;
                errorElementName = `${fieldName}---${i}---sx:pbtLocality`;
            }
            if (result && !isAbroad && !form.properties["sx:pbtTripGoal"]) {
                result = false;
                errorElementName = `${fieldName}---${i}---sx:pbtTripGoal`;
            }
            if (result && isAbroad && !form.properties["sx:pbtTripGoalForeign"]) {
                result = false;
                errorElementName = `${fieldName}---${i}---sx:pbtTripGoalForeign`;
            }
            if (result && !isAbroad && form.properties["sx:pbtTripGoal"] === constants.otherTripGoalValue && !form.properties["sx:pbtTripGoalComment"]) {
                result = false;
                errorElementName = `${fieldName}---${i}---sx:pbtTripGoalComment`;
            }
            if (result && isAbroad && form.properties["sx:pbtTripGoalForeign"] === constants.otherTripGoalValue && !form.properties["sx:pbtTripGoalComment"]) {
                result = false;
                errorElementName = `${fieldName}---${i}---sx:pbtTripGoalComment`;
            }
            break;
        case 2:
            if (isAbroad && documentData.properties["sx:btRouteType"] === routeCreatingTypes.auto) {
                break;
            }
            if (result && !documentData.properties["sx:btSameTransportForRoutes"] && !form.properties["sx:pbtMethodTransportation"]) {
                result = false;
                errorElementName = `${fieldName}---${i}---sx:pbtMethodTransportation`;
            }
            if (result && form.properties['travelForm']?.length > 0) {
                const travelForm = form.properties['travelForm'][0];
                if (result && fieldName !== 'goingBackForm' && (!travelForm.properties["sx:tfPoint"] || !travelForm.properties["sx:tfPointArrival"])) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---travelForm---0---routeInfo`;
                }
                if (result && !travelForm.properties["sx:tfDepartureDate"]) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---travelForm---0---placeStartEndDate`;
                }
                if (result && !documentData.properties["sx:btMultipleRoutes"] && form.properties['sx:pbtSameTransportBack'] && !travelForm.properties["sx:tfArrivalDate"]) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---travelForm---0---placeStartEndDate`;
                }
            }
            if (result && !documentData.properties["sx:btSameTransportForRoutes"] && form.properties["sx:pbtMethodTransportation"] === transportationMethods.autoColleagues) {
                if (!form.properties["assoc:sx:pbtColleague_added"]) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---assoc:sx:pbtColleague_added`;
                }
            }
            if (result && !documentData.properties["sx:btSameTransportForRoutes"] && (form.properties["sx:pbtMethodTransportation"] === transportationMethods.ownCar || form.properties["sx:pbtMethodTransportation"] === transportationMethods.carRental)) {
                const carInfoForm = form.properties['carInfoForm'][0];
                if (result && !carInfoForm.properties['sx:ciBrandCar']) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---carInfoForm---0---sx:ciBrandCar`;
                }
                if (result && !carInfoForm.properties['sx:ciRegNumerInfo']) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---carInfoForm---0---sx:ciRegNumerInfo`;
                }
                if (result && !carInfoForm.properties['sx:ciReleaseYear']) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---carInfoForm---0---sx:ciReleaseYear`;
                }
                if (result && !carInfoForm.properties['sx:ciEngineType']) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---carInfoForm---0---sx:ciEngineType`;
                }
                if (result && !carInfoForm.properties[`sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`]) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---carInfoForm---0---sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`;
                }
                if (result && !carInfoForm.properties['sx:ciEngineDisplacement']) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---carInfoForm---0---sx:ciEngineDisplacement`;
                }
                if (result && !carInfoForm.properties['sx:ciCarColor']) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---carInfoForm---0---sx:ciCarColor`;
                }
                if (result && form.properties["sx:pbtMethodTransportation"] === transportationMethods.ownCar) {
                    if (!(carInfoForm.properties["ownCarAttachments"]?.length > 0)) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---carInfoForm---0---ownCarAttachments`;
                    }
                }
                if (result && form.properties["sx:pbtMethodTransportation"] === transportationMethods.carRental) {
                    if (!(carInfoForm.properties["rentalCarBillAttachments"]?.length > 0)) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---carInfoForm---0---rentalCarBillAttachments`;
                    }
                    if (result && !(carInfoForm.properties["rentalCarActAttachments"]?.length > 0)) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---carInfoForm---0---rentalCarActAttachments`;
                    }
                }
            }
            if (result && !documentData.properties["sx:btSameTransportForRoutes"] && form.properties["sx:pbtMethodTransportation"] === transportationMethods.corporateCar) {
                if (!form.properties["sx:ciBrandCar"]) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---sx:ciBrandCar`;
                }
                if (result && !form.properties["sx:ciModelCar"]) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---sx:ciModelCar`;
                }
                if (result && !form.properties["sx:ciRegNumerInfo"]) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---sx:ciRegNumerInfo`;
                }
            }
            if (result && !form.properties['sx:pbtSameTransportBack'] && !documentData.properties["sx:btMultipleRoutes"]) {
                if (result && !form.properties['sx:pbtBackMethodTransportation']) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---sx:pbtBackMethodTransportation`;
                }
                if (result && !form.properties['dateStartBack']) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---placeBackStartEndDate`;
                }
                if (result && form.properties["sx:pbtBackMethodTransportation"] === transportationMethods.autoColleagues) {
                    if (form.properties['sys:node-uuid']) {
                        if (!form.properties["assoc:sx:pbtColleagueBack_added"]) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---assoc:sx:pbtColleagueBack_added`;
                        }
                    }
                    else if (!form.properties["sx:pbtColleagueBack"]) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---sx:pbtColleagueBack`;
                    }
                }
                if (result && (form.properties["sx:pbtBackMethodTransportation"] === transportationMethods.ownCar || form.properties["sx:pbtBackMethodTransportation"] === transportationMethods.carRental)) {
                    const carInfoForm = form.properties['carInfoBackForm'][0];
                    if (result && !carInfoForm.properties['sx:ciBrandCar']) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---carInfoBackForm---0---sx:ciBrandCar`;
                    }
                    if (result && !carInfoForm.properties['sx:ciRegNumerInfo']) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---carInfoBackForm---0---sx:ciRegNumerInfo`;
                    }
                    if (result && !carInfoForm.properties['sx:ciReleaseYear']) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---carInfoBackForm---0---sx:ciReleaseYear`;
                    }
                    if (result && !carInfoForm.properties['sx:ciEngineType']) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---carInfoBackForm---0---sx:ciEngineType`;
                    }
                    if (result && !carInfoForm.properties[`sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`]) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---carInfoBackForm---0---sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`;
                    }
                    if (result && !carInfoForm.properties['sx:ciEngineDisplacement']) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---carInfoBackForm---0---sx:ciEngineDisplacement`;
                    }
                    if (result && !carInfoForm.properties['sx:ciCarColor']) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---carInfoBackForm---0---sx:ciCarColor`;
                    }
                    if (result && form.properties["sx:pbtBackMethodTransportation"] === transportationMethods.ownCar) {
                        if (!(carInfoForm.properties["ownCarAttachments"]?.length > 0)) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---carInfoBackForm---0---ownCarAttachments`;
                        }
                    }
                    if (result && form.properties["sx:pbtBackMethodTransportation"] === transportationMethods.carRental) {
                        if (!(carInfoForm.properties["rentalCarBillAttachments"]?.length > 0)) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---carInfoBackForm---0---rentalCarBillAttachments`;
                        }
                        if (result && !(carInfoForm.properties["rentalCarActAttachments"]?.length > 0)) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---carInfoBackForm---0---rentalCarActAttachments`;
                        }
                    }
                }
                if (result && form.properties["sx:pbtBackMethodTransportation"] === transportationMethods.corporateCar) {
                    if (!form.properties["sx:ciBrandCarBack"]) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---sx:ciBrandCarBack`;
                    }
                    if (result && !form.properties["sx:ciModelCarBack"]) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---sx:ciModelCarBack`;
                    }
                    if (result && !form.properties["sx:ciRegNumerInfoBack"]) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---sx:ciRegNumerInfoBack`;
                    }
                }
            }
            if (result && isAbroad && form.properties["transitForm"]?.length > 0) {
                for (let j = 0; j < form.properties["transitForm"].length; j++) {
                    const transitForm = form.properties["transitForm"][j];
                    if (!transitForm.properties['sx:pbtCity']) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---transitForm---${j}---sx:pbtCity`;
                        break;
                    }
                    if (!transitForm.properties['transitDate']) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---transitForm---${j}---transitDate`;
                        break;
                    }
                    if (!transitForm.properties['sx:pbtMethodTransportation']) {
                        result = false;
                        errorElementName = `${fieldName}---${i}---transitForm---${j}---sx:pbtMethodTransportation`;
                        break;
                    }
                    if (transitForm.properties['sx:pbtMethodTransportation'] === transportationMethods.autoColleagues) {
                        if (transitForm.properties['sys:node-uuid'] && !transitForm.properties['assoc:sx:pbtColleague_added']) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---assoc:sx:pbtColleague_added`;
                            break;
                        }
                        if (!transitForm.properties['sys:node-uuid'] && !transitForm.properties['sx:pbtColleague']) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---sx:pbtColleague`;
                            break;
                        }
                    }
                    if (transitForm.properties['sx:pbtMethodTransportation'] === transportationMethods.corporateCar) {
                        if (!transitForm.properties["sx:ciBrandCar"]) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---sx:ciBrandCar`;
                            break;
                        }
                        if (result && !transitForm.properties["sx:ciModelCar"]) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---sx:ciModelCar`;
                            break;
                        }
                        if (result && !transitForm.properties["sx:ciRegNumerInfo"]) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---sx:ciRegNumerInfo`;
                            break;
                        }
                    }
                    if (transitForm.properties['sx:pbtMethodTransportation'] === transportationMethods.ownCar || transitForm.properties['sx:pbtMethodTransportation'] === transportationMethods.carRental) {
                        const carInfoForm = transitForm.properties['carInfoForm'][0];
                        if (result && !carInfoForm.properties['sx:ciBrandCar']) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---carInfoForm---0---sx:ciBrandCar`;
                        }
                        if (result && !carInfoForm.properties['sx:ciRegNumerInfo']) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---carInfoForm---0---sx:ciRegNumerInfo`;
                        }
                        if (result && !carInfoForm.properties['sx:ciReleaseYear']) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---carInfoForm---0---sx:ciReleaseYear`;
                        }
                        if (result && !carInfoForm.properties['sx:ciEngineType']) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---carInfoForm---0---sx:ciEngineType`;
                        }
                        if (result && !carInfoForm.properties[`sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`]) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---carInfoForm---0---sx:ciFuelType_${carInfoForm.properties['sx:ciEngineType']}`;
                        }
                        if (result && !carInfoForm.properties['sx:ciEngineDisplacement']) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---carInfoForm---0---sx:ciEngineDisplacement`;
                        }
                        if (result && !carInfoForm.properties['sx:ciCarColor']) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---carInfoForm---0---sx:ciCarColor`;
                        }
                        if (result && transitForm.properties["sx:pbtMethodTransportation"] === transportationMethods.ownCar) {
                            if (!(carInfoForm.properties["ownCarAttachments"]?.length > 0)) {
                                result = false;
                                errorElementName = `${fieldName}---${i}---transitForm---${j}---carInfoForm---0---ownCarAttachments`;
                            }
                        }
                        if (result && transitForm.properties["sx:pbtMethodTransportation"] === transportationMethods.carRental) {
                            if (!(carInfoForm.properties["rentalCarBillAttachments"]?.length > 0)) {
                                result = false;
                                errorElementName = `${fieldName}---${i}---transitForm---${j}---carInfoForm---0---rentalCarBillAttachments`;
                            }
                            if (result && !(carInfoForm.properties["rentalCarActAttachments"]?.length > 0)) {
                                result = false;
                                errorElementName = `${fieldName}---${i}---transitForm---${j}---carInfoForm---0---rentalCarActAttachments`;
                            }
                        }
                        if (!result) {
                            break;
                        }
                    }
                }
            }
            break;
        case 3:
            if (isAbroad && documentData.properties["sx:btRouteType"] === routeCreatingTypes.auto) {
                break;
            }
            if (result && form.properties["sx:btAccommodationRequired"] && form.properties['residenceStatusForm']?.length > 0) {
                const residenceStatusForm = form.properties['residenceStatusForm'][0];
                if (!residenceStatusForm.properties['sx:rsArrivalDate'] || !residenceStatusForm.properties['sx:rsDepartureDate']) {
                    result = false;
                    errorElementName = `${fieldName}---${i}---residenceStatusForm---0---residenceStartEndDate`;
                }
            }
            if (result && isAbroad && form.properties["transitForm"]?.length > 0) {
                for (let j = 0; j < form.properties["transitForm"].length; j++) {
                    const transitForm = form.properties["transitForm"][j];
                    if (transitForm.properties['sx:btAccommodationRequired']) {
                        if (!transitForm.properties['sx:pbtCity']) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---sx:pbtCity`;
                            break;
                        }
                        const residenceStatusForm = transitForm.properties['residenceStatusForm'][0];
                        if (!residenceStatusForm.properties['sx:rsArrivalDate'] || !residenceStatusForm.properties['sx:rsDepartureDate']) {
                            result = false;
                            errorElementName = `${fieldName}---${i}---transitForm---${j}---residenceStatusForm---0---residenceStartEndDate`;
                            break;
                        }
                    }
                }
            }
            break;
    }
    return {
        result,
        errorElementName,
        subform
    };
}

export function checkOperationForms(documentData) {
    let result = !!documentData.properties["operationForm"];
    let errorElementName = '';
    let errorElementId = '';
    let i = 0;
    if (result) {
        for (i = 0; i < documentData.properties["operationForm"].length; i++) {
            const form = documentData.properties["operationForm"][i];
            if (!form.properties["sx:opDirectionDeparture"]) {
                result = false;
                errorElementName = `operationForm---${i}---sx:opDirectionDeparture`;
                break;
            }
            if (!form.properties["sx:opOdometerStart"]) {
                result = false;
                errorElementName = `operationForm---${i}---sx:opOdometerStart`;
                break;
            }
            if (!form.properties["sx:opDirectionArrival"]) {
                result = false;
                errorElementName = `operationForm---${i}---sx:opDirectionArrival`;
                break;
            }
            if (!form.properties["sx:opOdometerEnd"]) {
                result = false;
                errorElementName = `operationForm---${i}---sx:opOdometerEnd`;
                break;
            }
            const odometrStart = form.properties['sx:opOdometerStart'];
            const odometrEnd = form.properties['sx:opOdometerEnd'];
            const odometrStartValue = parseFloat(odometrStart.replaceAll(' ', '').replace(',', '.'));
            const odometrEndValue = parseFloat(odometrEnd.replaceAll(' ', '').replace(',', '.'));
            if (odometrEndValue - odometrStartValue < 0.000009) {
                result = false;
                errorElementName = `operationForm---${i}---sx:opOdometerEnd`;
                break;
            }
            for (let j = 0; j < i; j++) {
                const odometrOperationEnd = documentData.properties["operationForm"][j].properties['sx:opOdometerEnd'];
                const odometrOperationEndValue = parseFloat(odometrOperationEnd.replaceAll(' ', '').replace(',', '.'));
                if (odometrStartValue - odometrOperationEndValue < -0.000009) {
                    result = false;
                    errorElementName = `operationForm---${i}---sx:opOdometerStart`;
                    break;
                }
            }
            if (result && (!form.properties["sx:attachments"] || form.properties["sx:attachments"]?.length < 2)) {
                result = false;
                errorElementId = `operationForm---${i}---sx:attachments`;
                break;
            }
            if (!result) break;
        }
    }
    return {
        result,
        errorElementName,
        errorElementId,
        formIndex: i
    };
}

export function checkReportForms(documentData) {
    let result = !!documentData.properties["reportForm"];
    let errorElementName = '';
    let errorElementId = '';
    let i = 0;
    if (result) {
        for (i = 0; i < documentData.properties["reportForm"].length; i++) {
            const form = documentData.properties["reportForm"][i];

            if (form.properties["sx:autofillObject"]) continue;

            if (!form.properties["sx:rpTypeExpenses"]) {
                result = false;
                errorElementName = `reportForm---${i}---sx:rpTypeExpenses`;
                break;
            }
            if (!form.properties["sx:rpConsumptionFrom"]) {
                result = false;
                errorElementName = `reportForm---${i}---sx:rpConsumptionFrom`;
                break;
            }
            if (!form.properties["sx:rpExpenseContent"]) {
                result = false;
                errorElementName = `reportForm---${i}---sx:rpExpenseContent`;
                break;
            }
            if (!form.properties["sx:rpAmountUAH"]) {
                result = false;
                errorElementName = `reportForm---${i}---sx:rpAmountUAH`;
                break;
            }
            if (!form.properties["sx:rpBasedOn"]) {
                result = false;
                errorElementName = `reportForm---${i}---sx:rpBasedOn`;
                break;
            }
            if (!form.properties["sx:rpDocumentNumber"]) {
                result = false;
                errorElementName = `reportForm---${i}---sx:rpDocumentNumber`;
                break;
            }
            if (!form.properties["sx:rpDocumentDate"]) {
                result = false;
                errorElementName = `reportForm---${i}---sx:rpDocumentDate`;
                break;
            }
            if (!form.properties["sx:rpTypeDocReport"]) {
                result = false;
                errorElementName = `reportForm---${i}---sx:rpTypeDocReport`;
                break;
            }
            if (!form.properties["sx:attachments"] || form.properties["sx:attachments"].length < 1) {
                result = false;
                errorElementId = `reportForm---${i}---sx:attachments`;
                break;
            }
        }
    }
    return {
        result,
        errorElementName,
        errorElementId,
        formIndex: i
    };
}

export function checkResultForms(documentData) {
    let result = !!documentData.properties["resultForm"];
    let errorElementName = '';
    let errorElementId = '';
    let i = 0;
    if (result) {
        for (i = 0; i < documentData.properties["resultForm"].length; i++) {
            const form = documentData.properties["resultForm"][i];

            if (!form.properties["sx:btrReportTask"]) {
                result = false;
                errorElementName = `resultForm---${i}---sx:btrReportTask`;
                break;
            }
            if (!form.properties["sx:btrReportResult"]) {
                result = false;
                errorElementName = `resultForm---${i}---sx:btrReportResult`;
                break;
            }
        }
    }
    return {
        result,
        errorElementName,
        errorElementId,
        formIndex: i
    };
}